// const { env } = require('../util/environment.util');

exports.appConfig = {
  // enableBlogPosts: /true/i.test(env('GATSBY_BLOG_ENABLED')),
  // previewUnpublishedContent: /true/i.test(env('GATSBY_PREVIEW_UNPUBLISHED_CONTENT')),
  enableBlogPosts: /true/i.test(`${process.env.GATSBY_BLOG_ENABLED}`),
  previewUnpublishedContent: /true/i.test(`${process.env.GATSBY_PREVIEW_UNPUBLISHED_CONTENT}`),
};
